import { graphql } from "babel-plugin-relay/macro";
import { commitMutation, Environment } from "react-relay";
import { AddOnlyIfTreeStateOrAdminVisibilityTreeConfigInput } from "../../../../../../../../__generated__/OnlyIfTreeStateOrAdminVisibilityConfigForm_AddInfectopharmOnlyAdminsVisibilityConfigMutation.graphql";
import { OnlyBasicSeminarVisibilityConfig_AddMutation } from "../../../../../../../../__generated__/OnlyBasicSeminarVisibilityConfig_AddMutation.graphql";

const MUTATION = graphql`
	mutation OnlyBasicSeminarVisibilityConfig_AddMutation(
		$input: AddOnlyBasicSeminarVisibilityTreeConfigInput!
	) {
		Admin {
			Tree {
				AddOnlyBasicSeminarVisibilityTreeConfig(input: $input) {
					rootNode {
						... on TreeNode {
							id
							structureDefinition {
								... on RootStructureDefinition {
									visibilityConfigs {
										... on OnlyBasicSeminarVisibilityTreeConfig {
											id
											configType
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

function CommitOnlyBasicSeminarVisibilityConfig(
	environment: Environment,
	input: AddOnlyIfTreeStateOrAdminVisibilityTreeConfigInput,
) {
	return commitMutation<OnlyBasicSeminarVisibilityConfig_AddMutation>(environment, {
		mutation: MUTATION,
		variables: { input },
		onCompleted: () => {},
		onError: () => {},
	});
}

export { CommitOnlyBasicSeminarVisibilityConfig as AddInfectopharmOnlyBasicSeminarVisibilityConfig };
